const theme = {
  radius: {
    small: "6px",
    medium: "10px",
    big: "24px"
  },
  spacing: 4,
  palettes: {
    bg: {
      primary: "#16161a",
      secondary: "#242629"
    },
    text: {
      primary: "#FFFFFF",
      secondary: "#94a1b2"
    },
    color1: {
      primary: "#00FF8E",
      secondary: "#161730"
    },
    color2: {
      primary: "#9013FE",
      secondary: "#200737"
    },
    color3: {
      primary: "#FF0D70",
      secondary: "#27072E"
    },
    color4: {
      primary: "#FFF35C",
      secondary: "#27172C"
    },
    accent: {
      primary: "#00FF8E",
      secondary: "#58FFB5"
    }
  }
};

export const breakpoints = {
  mobile: 320,
  mobileLandscape: 480,
  tablet: 768,
  tabletLandscape: 1024,
  desktop: 1200,
  desktopLarge: 1500,
  desktopWide: 1920
};

export const getSpacing = n => `${theme.spacing * n}px`;

export default theme;
